import { render } from "./XeroConnect.vue?vue&type=template&id=0c579795&scoped=true"
import script from "./XeroConnect.vue?vue&type=script&lang=js"
export * from "./XeroConnect.vue?vue&type=script&lang=js"

import "./XeroConnect.vue?vue&type=style&index=0&id=0c579795&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c579795"]])

export default __exports__